<template>
<span v-if="showAddPallet()">
  <el-button id="btn-add-pallet-receipt" type="success" plain @click="dialogVisible = true" size="mini">{{ $t('palletReceipt.addPallet') }}</el-button>
  <el-dialog
  id="add-pallet-receipt-dialog"
  :close-on-click-modal="false"
  v-on:open="handleOpen"
  :title="$t('palletReceipt.addPallet')"
  :visible.sync="dialogVisible"
  width="65%"
  class="dialog-with-cols"
  :before-close="handleClose">
  <el-form :model="form" :rules="formRules" ref="form" size="mini">
      <el-row>
         <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('palletReceipt.warehouse')" prop="warehouse" class="inline-input">
                  <el-input
                   v-model="user.warehouseCode"
                  disabled
                  id="form-warehouse"
                  ></el-input>
              </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('palletReceipt.shipper')" class="shipper-filter shipper-wrp" prop="shipperAccountId">
              <autocomplete
                :model.sync="form.shipperAccountId"
                :url="urlShipperAutocomplete"
                :warehouseId="user.warehouseId"
                labelField="name"
                labelFieldLastWithDash="number"
                :classCss="null"
                valueField="id"
                id="pallet-receipt-form-shipper"
                ref="pallet-receipt-form-shipper"
              />
              </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('palletReceipt.dayOfService')" prop="receivingDate" class="inline-input">
                <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                size="mini"
                v-model="form.receivingDate"
                format="MM/dd/yyyy"
                type="date"
                id="pallet-receipt-form-date-of-service"
              ></el-date-picker>
              </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('palletReceipt.validNumber')" prop="numberOfValid">
                  <el-input-number
                  @change="calculateRedeemablePallet"
                  v-model="form.numberOfValid"
                  v-numeric-validation
                  maxlength="10"
                  :min="0" :max="9999"
                  :controls="false"
                  class="inline-input width-100p"
                  id="pallet-receipt-form-validpallet"
                  ></el-input-number>
              </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('palletReceipt.invalidNumber')" prop="numberOfInvalid">
                  <el-input-number
                  @change="calculateRedeemablePallet"
                  v-model="form.numberOfInvalid"
                  v-numeric-validation
                  maxlength="10"
                  :controls="false"
                  :min="0" :max="9999"
                  class="inline-input width-100p"
                  id="pallet-receipt-form-invalidpallet"
                  ></el-input-number>
              </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('palletReceipt.redeemable')" prop="redeemablePallet">
                  <el-input
                  v-model="redeemablePallet"
                  maxlength="10"
                  disabled
                  class="inline-input"
                  id="pallet-receipt-form-redeemablePallet"
                  ></el-input>
              </el-form-item>
          </el-col>
      </el-row>
  </el-form>
  <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button type="primary" id="form-save-button" @click="submitForm()" size="mini">{{ $t('palletReceipt.addPallet') }}</el-button>
      <el-button id="form-refresh-button" @click="resetForm()" size="mini">{{ $t('palletReceipt.clear') }}</el-button>
  </div>
  </el-dialog>
</span>
</template>

<script>
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import apiConstants from '@/utils/apiConstants';
import constants from '@/utils/constants';
import Autocomplete from '@/components/Autocomplete';
import palletReceiptService from '@/api/palletReceiptService';

export default {
  components: { Autocomplete },
  computed: {
    ...mapGetters([
      'palletReceipt', 'user'
    ])
  },
  data() {
    const validateRedeemable = (rule, value, callback) => {
      if (this.redeemablePallet <= 0) {
        callback(new Error(this.$t('palletReceipt.error.redeemablePalletNotZero')));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      form: {
        shipperAccountId: null,
        receivingDate: new Date(),
        numberOfValid: null,
        numberOfInvalid: 0
      },
      redeemablePallet: null,
      invalidPalletDeduction: null,
      urlShipperAutocomplete: apiConstants.END_POINTS.ACCOUNTS.SHIPPERS,
      formRules: {
        shipperAccountId: [
          { required: true, message: this.$t('palletReceipt.error.shipperAccountRequired'), trigger: 'submit' }
        ],
        receivingDate: [
          { required: true, message: this.$t('palletReceipt.error.dayOfServiceRequired'), trigger: 'blur' }
        ],
        numberOfValid: [
          { required: true, message: this.$t('palletReceipt.error.validPalletRequired'), trigger: 'blur' }
        ],
        numberOfInvalid: [
          { required: true, message: this.$t('palletReceipt.error.invalidPalletRequired'), trigger: 'blur' }
        ],
        redeemablePallet: [
          { validator: validateRedeemable, trigger: 'submit' }
        ]
      }
    };
  },
  mounted() {
    palletReceiptService.getSettings().then(({ data: invalidPalletDeduction }) => {
      this.invalidPalletDeduction = invalidPalletDeduction;
    });
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    handleClose(done) {
      done();
    },
    calculateRedeemablePallet() {
      this.redeemablePallet = (this.form.numberOfValid - (this.form.numberOfInvalid * this.invalidPalletDeduction)) || 0;
    },
    async submitForm() {
      const validForm = await this.$refs.form.validate().catch(() => {});
      if (!validForm) {
        return;
      }

      Message.closeAll();
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);

      try {
        const response = await this.$store.dispatch('palletReceipt/save', this.form);
        loading.close();
        this.$message.success(response.message);
        this.$store.dispatch('palletReceipt/shipperSearch', {});
        this.resetForm();
      } finally {
        loading.close();
      }
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.shipperAccountId = null;
      this.form.receivingDate = new Date();
      this.form.numberOfValid = null;
      this.form.numberOfInvalid = 0;
      this.redeemablePallet = 0;

      if (this.$refs['pallet-receipt-form-shipper']) {
        this.$refs['pallet-receipt-form-shipper'].clearLocalModel();
      }
    },
    showAddPallet() {
      return this.$can(this.permissions.WAREHOUSE.CREATE_PALLET_RECEIPT);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">

#add-pallet-receipt-dialog {
  .el-date-editor {
    width: 100% !important;
  }
}
</style>
